module.exports = __webpack_public_path__ + "img/bebio777_Logo.b0eba194.png";